var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgXbutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4139 12L15.7069 9.707C16.0974 9.3165 16.0974 8.6835 15.7069 8.293C15.3164 7.9025 14.6834 7.9025 14.2929 8.293L11.9999 10.586L9.70687 8.293C9.31687 7.9025 8.68287 7.9025 8.29287 8.293C7.90238 8.6835 7.90238 9.3165 8.29287 9.707L10.5859 12L8.29287 14.293C7.90238 14.6835 7.90238 15.3165 8.29287 15.707C8.48787 15.9025 8.74387 16 8.99987 16C9.25587 16 9.51187 15.9025 9.70687 15.707L11.9999 13.414L14.2929 15.707C14.4884 15.9025 14.7439 16 14.9999 16C15.2559 16 15.5114 15.9025 15.7069 15.707C16.0974 15.3165 16.0974 14.6835 15.7069 14.293L13.4139 12Z",
    fill: "#004E5E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXbutton);
export default __webpack_public_path__ + "static/media/Xbutton.6815853d8fdf9161eeb07b695404e8fb.svg";
export { ForwardRef as ReactComponent };